import { Component, OnInit, HostListener, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogConfig, MatMenuTrigger } from '@angular/material';
import * as _ from 'lodash';
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order/purchase-order.service';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { SupplierDetails } from 'src/app/core/enum/supplier-details.enum';
import { ActionConfirmationModalComponent } from 'src/app/shared/components/action-confirmation-modal/action-confirmation-modal.component';
import { dialogMesasage } from 'src/app/core/enum/dialog-box-message.enum';
import { EditSupplierComponent } from '../edit-supplier/edit-supplier.component';
import { SupplierUserOrders } from 'src/app/core/enum/supplier-user-orders.enum';
import { AddSupplierUserComponent } from 'src/app/components/users/add-supplier-user/add-supplier-user.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { DeleteUserComponent } from 'src/app/components/users/delete-user/delete-user.component';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { AddSupplierCustomerComponent } from '../../customers/add-supplier-customer/add-supplier-customer.component';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'


@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.scss'],
})
export class SupplierComponent implements OnInit {
  private sub: any;
  public params: any;
  public supplier: any;
  public supplierUsers: any[] = [];
  public filteredSupplierUsers: any[] = [];
  public filteredHeader: string;
  public promptDeleteUser: boolean = false;
  private mobileActionsSubscription: any;
  public userToDelete: any;
  public loading: boolean = false;
  public p: any;
  public masterLocation = {};
  public poCount = 0;
  public selected = 'users';
  public customers: any;
  public subuserTitle = '';
  public urlPath: any;
  public filterSearch;
  public BackendData: boolean = false;
  public supplierUsersOrders;
  public supplierDetails = [
    SupplierUserOrders.USERS,
    SupplierUserOrders.ASSOCIATIONS,
    SupplierUserOrders.LOCATIONS,
    SupplierUserOrders.PURCHASEORDERS,
  ];
  minDesktopWidth: any = 991;
  minDropDownWidth: any = 540;
  isMobile: boolean;
  roleDropDown: boolean;
  mobileOverlayRef: any;
  innerWidth: number;
  public notifications: any[] = [];

  editSupplierDialogParameters: MatDialogConfig<any> = {
    maxHeight: '90vh',
    panelClass: ['modal'],
    autoFocus: false,
  };

  deleteSupplierDialogParameters: MatDialogConfig<any> = {
    panelClass: 'custom-dialog-container',
    autoFocus: false
  };


  @ViewChild('menuTrigger', { static: false }) menuTrigger: MatMenuTrigger;
  @HostListener('window:scroll', [])
  scrollHandler() {
    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }
  }


  constructor(
    private supplierService: SupplierService,
    private location: Location,
    private route: ActivatedRoute,
    public currentUserService: CurrentUserService,
    private _redirectUrl: RedirctUrlService,
    private purchaseOrderService: PurchaseOrderService,
    public header: HeaderService,
    public dialog: MatDialog,
    private modal: ModalService,
    private cdRef: ChangeDetectorRef,
    private flashMessageService: FlashMessageService,
    private _customerSvc: CustomerService,
    public appNotificationsService: AppNotificationService) { }
  currentUser: string;

  // To detect screen window size
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    this.roleDropDown = this.innerWidth <= this.minDropDownWidth;
    if (this.innerWidth <= this.minDesktopWidth) {
      this.isMobile = true;
      this._initializeActionsBar();
    } else {
      this.isMobile = false;
      if (this.mobileOverlayRef) {
        this.mobileOverlayRef.dispose();
        this.header.headerTitle = 'Supplier Details';
        this.header.setBackVisibilityEvent(false);
      }
    }
  }

  async ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.roleDropDown = this.innerWidth <= this.minDropDownWidth;
    if (this.innerWidth <= this.minDesktopWidth) {
      this.isMobile = true;
      this._initializeActionsBar();
      this.supplierUsersOrders = SupplierUserOrders.USERS.label;
    }
    this.currentUserService.getUser().then(user => {
      this.currentUser = this.currentUserService.user.firstname;
    });

    this.loading = true;
    this.getSupplier();
    this.urlPath = this.route.snapshot;

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngOnDestroy() {
    
  }

  public getSupplier() {
    this.loading = true;
    this.header.metrics = [];
    this.sub = this.route.params.subscribe(params => {
      this.supplierService.getSupplierDetail(params['id']).then(resp => {
        this.supplier = resp;
        this.header.metrics[1] = {
          link: '',
          label: SupplierDetails.LOCATIONS.label,
          amount: this.supplier.locations.length,
          clicked: false,
        };
        this.saveMasterLocation();
        this.getSupplierUsers();
        this.getSupplierCustomers(this.supplier.id);
        this.getSupplierPoCount(this.supplier.id, 'supplier');
      });
    });
  }

  public getSupplierPoCount(id, type) {
    this.purchaseOrderService.getPurchaseOrderCount(id, type).then(count => {
      this.poCount = count; // PO Count
      this.header.metrics[0] = {
        link: '',
        label: SupplierDetails.PURCHASEORDERS.label,
        amount: this.poCount,
        clicked: false,
      };
    });
  }

  public getSupplierCustomers(id) {
    this.supplierService.getSupplierCustomers(id).then(customers => {
      this.customers = customers; // Associations count
      this.header.metrics[2] = {
        link: '',
        label: SupplierDetails.ASSOCIATIONS.label,
        amount: this.customers.length,
        clicked: false,
      };
    });
  }

  public getSupplierUsers() {
    this.loading = true;
    this.supplierService
      .getSupplierUsers(this.supplier.id)
      .then(resp => {
        this.supplierUsers = resp;
        this.header.metrics[3] = {
          link: '',
          label: SupplierDetails.USERS.label,
          amount: this.supplierUsers.length,
          clicked: true,
        };
        // this.filterSupplierUsers('all');
        this.cdRef.detectChanges();
        this.loading = false;
      })
      .catch(e => {
        this.loading = false;
      });
  }

  public closeModal() {
    this.userToDelete = null;
    this.getSupplier();
  }

  public back() {
    this.location.back();
  }

  public saveMasterLocation() {
    this.masterLocation = this.supplier.locations.find(element => {
      return element.locationMasterId === this.supplier.master_location_id;
    });
    Object.assign(this.supplier, { masterLocation: this.masterLocation });
  }


  unlinkLocation(locationMasterId) {
    this.loading = true;
    this.supplierService
      .unlinkLocation(locationMasterId, this.supplier.id)
      .then(() => {
        _.remove(this.supplier.locations, { locationMasterId: locationMasterId });
        this.loading = false;
      })
      .catch(e => {
        this.loading = false;
      });
  }

  onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  onBackEventHandler() {
    this.location.back();
  }

  ProcessMetricsEvent(metricLabel, index = -1) {
    let matricLowerCase = metricLabel.toLowerCase();
    this.supplierUsersOrders = _.upperFirst(matricLowerCase);
    if (!this.isMobile) {
      _.map(this.header.metrics, metric => {
        metric.clicked = false;
        return metric;
      });
      this.header.metrics[index].clicked = true;
    }
    switch (metricLabel.toLowerCase()) {
      case 'users':
        this.selected = SupplierDetails.USERS.label.toLowerCase();
        break;
      case 'associations':
        this.selected = SupplierDetails.ASSOCIATIONS.label.toLowerCase();
        break;
      case 'locations':
        this.selected = SupplierDetails.LOCATIONS.label.toLowerCase();
        break;
      case 'pos':
        this.selected = 'pos';
        break;
    }
  }

  public modifySupplierInfo(supplier) {
    this.editSupplierDialogParameters.data = {
      supplierDetails: supplier,
      sourceComponent: 'supplierComponentModify',
    };
    this.editSupplierDialogParameters.disableClose = true;
    let dialogRef1 = this.dialog.open(EditSupplierComponent, this.editSupplierDialogParameters);
    dialogRef1.componentInstance.confirmationAction.subscribe(confirmation => {
      if (confirmation.sourceComponent === 'supplierComponentModify') {
        if (confirmation.event === 'Confirm') {
          confirmation.supplierUpdate.domainName = 'CORP';
          confirmation.supplierUpdate.supplierId = supplier.id;
          confirmation.supplierUpdate.currentMasterLocation = supplier.master_location_id;
          confirmation.supplierUpdate.contacts = [{
            phone: confirmation.supplierUpdate.phoneContact,
            email: confirmation.supplierUpdate.emailContact,
            name: confirmation.supplierUpdate.nameContact
          }];
          delete confirmation.supplierUpdate.phoneContact;
          delete confirmation.supplierUpdate.emailContact;
          delete confirmation.supplierUpdate.nameContact;
          this.supplierService
            .updateSupplier(supplier.id, confirmation.supplierUpdate)
            .then((updatedSupplierInfo) => {
              this.ngOnInit();
            })
            .catch(err => {
              this.flashMessageService.updateMessage('Error while deleting. Please try again in sometime!');
            });
          dialogRef1.close();
        } else if (confirmation.event === 'Cancel') {
          dialogRef1.close();
        }
      }
    });
  }

  public deleteSupplier(supplierID) {
    let bodyTextToDisplay, allowSupplierDelete;
    if (this.supplierUsers.length === 0 && this.customers.length === 0) {
      bodyTextToDisplay = dialogMesasage.SUPPLIERALLOWDELETE.replace(/supplier/g, supplierID);
      allowSupplierDelete = true;
    } else {
      bodyTextToDisplay = dialogMesasage.SUPPLIERDONTALLOWDELETE.replace(/supplier/g, supplierID);
      allowSupplierDelete = false;
    }
    this.deleteSupplierDialogParameters.data = {
      sourceComponent: 'supplierComponent',
      headerText: `Confirmation`,
      bodyText: bodyTextToDisplay,
      btnConfirm: `Delete Supplier`,
      btnCancel: 'Cancel',
      allowDelete: allowSupplierDelete,
    };
    this.modal.open(ActionConfirmationModalComponent, this.deleteSupplierDialogParameters);

    let subscribe = this.modal.closeEvent.subscribe(confirmation => {
      if (confirmation.sourceComponent === 'supplierComponent') {
        if (confirmation.event === 'Confirm') {
          this.supplierService
            .deleteSupplier(supplierID)
            .then(() => {
              this._redirectUrl.onRedirectHandler({ url: '/suppliers', title: 'Suppliers' });
            })
            .catch(err => {
              this.flashMessageService.updateMessage('Error while deleting. Please try again in sometime!');
            });
        }

      }
      subscribe.unsubscribe();
    });
  }

  public mobileLoadActionsEvent(event) {
    this.header.setActionsMenuVisibilityEvent(true);
  }

  private _initializeActionsBar() {
    this.mobileActionsSubscription = this.header.showActionsMenu.subscribe(data => {
      if (this.menuTrigger)
        if (this.menuTrigger.menuOpen) {
          this.menuTrigger.closeMenu();
        } else {
          this.menuTrigger.openMenu();
        }
    });
  }

  openModal(type: string, data = null) {
    if (type === 'addUser') {
      this.modal.open(AddSupplierUserComponent, this.supplier.id);
    } else if (type === 'deleteUser') {
      if (data) {
        this.userToDelete = data;
      } else {
        this.flashMessageService.updateMessage("User data to delete was not found", 3000, "danger")
        return;
      }
      let subscription = this.modal.closeEvent.subscribe(() => {
        this.closeModal();
        subscription.unsubscribe();
      })
      this.modal.open(DeleteUserComponent, this.userToDelete);
    } else { }
  }

  onAddUser() {
    this.modal.open(AddSupplierUserComponent, { supplierId: this.supplier.id });
  }

   /**
   * @param
   * links customer to Supplier. Calls the diaog to select customer and saves the data to the backend
   */


  onAddCustomer() {
    this.modal.open(AddSupplierCustomerComponent);
    let subscribe = this.modal.closeEvent.subscribe(result => {
      if (result) {
        const payload = {
          custID : result[0].erpCustomerID,
          suppID: this.supplier
        };
        this.supplierService.linkCustomer(payload).then(xrefAdded => {
          xrefAdded['customerDetails'] = { name : result[0].custname };
          this.customers.customers.push(xrefAdded);
          this.header.metrics[2].amount = this.customers.length + 1;
      }).catch(err => {
        this.flashMessageService.updateMessage('Failed to Add Customer.Please try again in sometime!!');
      });
      }
      subscribe.unsubscribe();
    });
  }

  removeSupplierUser(user) {
    this.supplierUsers = this.supplierUsers.filter(item => item !== user);
  }

  associationsCountUpdate(countObj) {
    this.header.metrics[2].amount = countObj.count;
  }

  usersCountUpdate() {
    this.header.metrics[3].amount = this.supplierUsers.length + 1;
  }
}
